"use strict";
// Calendar month names, once.
//
// WHY IT IS SHARED. The same twelve strings were declared four times — twice in
// `frontend/` (`pages/Budgets.tsx`, `components/calendar/CalendarGrid.tsx`) and
// twice in `mobile/` (`app/(drawer)/budgets/index.tsx`,
// `components/calendar/MonthNavigation.tsx`) — by the month pickers and the
// calendar headers that a user moves between in one session (#755). Four copies
// of a list this boring is not a correctness risk on the day it is written; it
// is how a fifth copy gets a different abbreviation later, on the one surface
// nobody re-reads.
//
// These are English month names as product copy, not a localisation layer. A
// surface that needs the user's locale should format a real date through
// `Intl.DateTimeFormat` rather than index this array.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTH_NAMES = void 0;
/** January … December, index 0-11, matching `Date.prototype.getMonth()`. */
exports.MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
//# sourceMappingURL=calendarNames.js.map